import DateParserModule from './date-parser';
import template from './monthpicker.jade';

export class MonthpickerController {
  /* @ngInject */
  constructor() {
    this.today = moment().startOf('day').toDate();
    if(this.date == null) {
      if(this.setDefaultInitialValue) {
        this.current = this.today;
      }
    } else {
      this.current = moment(this.date);
    }

    this.months = [
      {id: '0', name: 'Jan'},
      {id: '1', name: 'Feb'},
      {id: '2', name: 'Mar'},
      {id: '3', name: 'Apr'},
      {id: '4', name: 'May'},
      {id: '5', name: 'Jun'},
      {id: '6', name: 'Jul'},
      {id: '7', name: 'Aug'},
      {id: '8', name: 'Sep'},
      {id: '9', name: 'Oct'},
      {id: '10', name: 'Nov'},
      {id: '11', name: 'Dec'}
    ];

    this.buildQuarters();
  }

  get showError() {
    return this.options && this.options.formControl && !_.isEmpty(this.options.formControl.$error);
  }

  get currentMonth() {
    return String(this.current.getMonth());
  }

  set currentMonth(month) {
    this.current = moment(this.current).month(parseInt(month)).toDate();
  }

  get years() {
    return _.range(-1, 2).map(n => {
      return moment(this.current).add(n, 'years').toDate().getFullYear();
    });
  }

  get currentYear() {
    return this.current.getFullYear();
  }

  set currentYear(year) {
    this.current = moment(this.current).year(year).toDate();
  }

  buildQuarters() {
    this.quarters = [
      [
        this.months[0],
        this.months[1],
        this.months[2]
      ],
      [
        this.months[3],
        this.months[4],
        this.months[5]
      ],
      [
        this.months[6],
        this.months[7],
        this.months[8]
      ],
      [
        this.months[9],
        this.months[10],
        this.months[11]
      ]
    ];
  }

  next() {
    this.current = moment(this.current).add(1, 'year').toDate();
  }

  prev() {
    this.current = moment(this.current).subtract(1, 'year').toDate();
  }

  monthClasses(monthShort) {
    let isSelected = false;
    if (this.date instanceof Date && isFinite(this.date)) {
      let getMonthResult = this.date.getMonth ? this.date.getMonth() : console.log('this.date', this.date);
      let monthResult = this.date.month && this.date.month();
      isSelected = monthShort.name == this.months[this.date.getMonth()].name;
    }
    //let isToday = moment.utc(monthShort).isSame(this.today, 'day');
    //let isDifferentMonth = monthShort.getFullYear() != this.current.getFullYear() ||
    //  monthShort.getMonth() != this.current.getMonth();

    return _.pickBy({
      'is-active': isSelected,
      //'is-different-month': isDifferentMonth,
      'c-calendar__day--start-range': isSelected,
      'c-calendar__day--end-range': isSelected,
      //'c-calendar__day--today': isToday
    }, value => value);
  }

  close() {
    // defined in link
  }

  select(month) {
    this.close();
    this.date = moment([this.currentYear,month.id,1]).toDate();
  }

  onChange() {
    if (_.isDate(this.date)) {
      this.current = this.date;
    }
  }
}

export function MonthpickerComponent() {
  return {
    template,
    controller: MonthpickerController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      date: '=ngModel',
      required: '=ngRequired',
      setDefaultInitialValue: '=setDefaultInitialValue',
      options: '='
    },
    bindToController: true,
    link: function (scope, element, attrs) {
      let openClass = 'is-open';

      scope.vm.close = (() => {
        element.find('.c-picker').removeClass(openClass);
      });

      element.find('.c-picker__input').click(function (event) {
        element.find('.c-picker').addClass(openClass);
      });

      // we need to use mousedown due to angular bug (ignores first click when input has focus)
      element.parents('body').bind('mousedown', (event) => {
        if (!element[0].contains(event.target)) {
          scope.$apply(() => {
            element.find('.c-picker').removeClass(openClass);
          });
        }
      });
    }
  };
};

export default angular.module('app.datetime.monthpicker', [
  DateParserModule.name
])
.directive('monthpicker', MonthpickerComponent);



/** WEBPACK FOOTER **
 ** ./src/common/datetime/monthpicker.js
 **/